import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import Button from '../../buttons/Button';//eslint-disable-line import/no-named-as-default
import ProducerNotes from '../../objects/producerNotes/ProducerNotes';
import NotReadyYet from '../../objects/producerNotes/NotReadyYet';
import EndOfScreen from '../../objects/producerNotes/EndOfScreen';
import ProtoType from '../../objects/prototypeObjects/PrototypeConversation';
import * as trackingDataActions from '../../../actions/trackingDataActions';
import * as appDataActions from '../../../actions/appDataActions';
import * as userDataActions from '../../../actions/userDataActions';
import * as appHelper from '../../../helpers/appHelper';
import * as dataHelper from '../../../helpers/dataHelper';
import {getAssetComponentByType} from '../../../helpers/componentHelper';
import * as userDataHelper from '../../../helpers/userDataHelper';
import * as enviromentHelper from '../../../helpers/environmentHelper';
import * as appConstants from '../../../constants/appConstants';
import * as objectConstants from '../../../constants/objectConstants';
import * as componentConstants from '../../../constants/componentConstants';
import * as localStorage from '../../../localStorage/localStorage';
import {TweenLite, Elastic, Bounce, Expo, ScrollTo,Linear} from 'gsap';
import gsap from 'gsap-react-plugin';
import _ from 'lodash';
import * as animationHelper from "../../../helpers/animationHelper";

class ScenarioScreen extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            lang: props.lang,
            screen: props.screen,
            userData: props.userData,
            showContentOutlineInPreview: props.showContentOutlineInPreview,
            env: enviromentHelper.getEnvironment(),
            locale: {},
            status: objectConstants.STATUS_NOT_STARTED,
            initialStatus: "",
            multiPath: appHelper.isDefined(this.props.screen.multi_path) ? this.props.screen.multi_path : {enabled: false},
            allowReviewMode: true,
            reviewMode: false,
            propsUpdated: false,
            renderedObjects: [],
            updateCharacter: false,
            screenCharacter: {},
            assets: {
                background: {
                    src: "",
                    type: "",
                    type_id: ""
                },
                character: {
                    src: "",
                    pose: "",
                    position: ""
                },
                prevCharacter: {
                    src: "",
                    pose: "",
                    position: ""
                }
            },

            parentBackground: {
                src: "",
                type: "",
                type_id: ""
            },
            callbacks: {
                updateCharacterExpression: null,
                onObjectComplete: null,
            },
            currentObjectIndex: 0,
            showProgression: false,
            allowGoToScreen: false,
            goToScreenId: 0,
            terminateScreen: false,
            terminateBite: false,
            producerNotes: appHelper.getScreenNotes(this.props.parentScreen, this.props.screen, this.props.showContentOutlineInPreview, props.contentData.experience.is_preview),
            screenIsReady: this.props.screen.objects.length > 0,// && (appHelper.canSeeContent(this.props.screen) || appHelper.isDefined(this.props.parentScreen)),
            allowClippedBlurEffect: appHelper.allowClippedBlurEffect(),
            allowBlur: dataHelper.cssPropertyValueSupported('filter', 'blur(3px)'),
            allowScroll: false,
            hasReceivedFocus: false,
            focusOnNextObject: false,
            scrollHeight: 0,
            continue_label: appHelper.getLocaleString("continue_label"),
            setNextButton: false,
            showEndOfScreenMessage: false,
            bannerInterval:{},
            backgroundPosition: "top",
            scrollToContent: false,
        };
        this.getLocale = this.getLocale.bind(this);
        this.getObject = _.debounce(this.getObject.bind(this), 300);
        this.getScreenId = this.getScreenId.bind(this);
        this.getBiteId = this.getBiteId.bind(this);
        this.isReviewMode = this.isReviewMode.bind(this);
        this.getImagePath = this.getImagePath.bind(this);
        this.getAssets = this.getAssets.bind(this);
        this.storeUserResponse = this.storeUserResponse.bind(this);
        this.setCallbacks = this.setCallbacks.bind(this);
        this.updateCharacterExpression = this.updateCharacterExpression.bind(this);
        this.onObjectComplete = this.onObjectComplete.bind(this);
        this.updateScreenResults = _.debounce(this.updateScreenResults.bind(this), 300);
        this.setScreenAccessed = _.debounce(this.setScreenAccessed.bind(this), 300);
        this.showProgressionButton = this.showProgressionButton.bind(this);
        this.navigateToNextScreen = this.navigateToNextScreen.bind(this);
        this.scrollTo = this.scrollTo.bind(this);
        this.onScrollComplete = this.onScrollComplete.bind(this);
        this.onContinueBtnReveled = this.onContinueBtnReveled.bind(this);
        this.scrollToTop = this.scrollToTop.bind(this);
        this.checkScreenStatus = this.checkScreenStatus.bind(this);
        this.setReviewMode = this.setReviewMode.bind(this);
        this.renderAllObjects = this.renderAllObjects.bind(this);
        this.transitionCharacterExpressions = this.transitionCharacterExpressions.bind(this);
        this.transitionCharacter = this.transitionCharacter.bind(this);
        this.transitionPrevCharacter = this.transitionPrevCharacter.bind(this);
        this.goToScreen = this.goToScreen.bind(this);
        //new
        this.getCharacterName = this.getCharacterName.bind(this);
        this.handleObjectProgression = this.handleObjectProgression.bind(this);
        this.hasNextObject = this.hasNextObject.bind(this);
        this.getScreenStatus = this.getScreenStatus.bind(this);
        this.getSubScreenParent = this.getSubScreenParent.bind(this);
        this.setScreenNotReadyYet = this.setScreenNotReadyYet.bind(this);
        this.getFeedClass = this.getFeedClass.bind(this);
        this.getPanelStyle = this.getPanelStyle.bind(this);
        this.scrollToOnComplete = this.scrollToOnComplete.bind(this);
        this.setFocusRecieved = this.setFocusRecieved.bind(this);
        this.focusOnNext = this.focusOnNext.bind(this);
        this.setScrollHeight = this.setScrollHeight.bind(this);
        this.resizeWatcher = this.resizeWatcher.bind(this);
        this.allowInheritParentPanelStyle = this.allowInheritParentPanelStyle.bind(this);
        this.goToMenu = this.goToMenu.bind(this);
        this.handleContinue = this.handleContinue.bind(this);

        this.getProducerContentClass = this.getProducerContentClass.bind(this);
        this.getProducerContentHeight = this.getProducerContentHeight.bind(this);
        this.getNextlessonLocation = this.getNextlessonLocation.bind(this);
        this.handleNextButton = this.handleNextButton.bind(this);
        this.checkLearnerDisplayName = this.checkLearnerDisplayName.bind(this);
        this.goToMenu = this.goToMenu.bind(this);
        this.checkScreenState = this.checkScreenState.bind(this);
        this.setBannerInterval = this.setBannerInterval.bind(this);
        this.getBackgroundBannerPlacement = this.getBackgroundBannerPlacement.bind(this);
        this.scrollToContent = this.scrollToContent.bind(this);

        this.objectFeed = React.createRef();
        this.objectFeedContainer = React.createRef();
        this.startBanner = React.createRef();
        this.bottomAnchor = React.createRef();
    }

    componentDidMount() {
        this.props.actions.setNextButtonState(false);
        window.addEventListener("resize", this.resizeWatcher);
        this.setScreenAccessed();
        if (this.props.audio.audioRef.length > 0) {
            this.props.actions.clearAudio();
        }

        this.props.biteCallbacks.showHeader(true);
        this.setCallbacks();
        this.getLocale();
        if (this.state.screenIsReady) {
            let getObject = this.getObject;
            let currentObjectIndex = this.state.currentObjectIndex;

            setTimeout(function () {
                getObject(currentObjectIndex);
            }, 100);
            // this.getObject(this.state.currentObjectIndex);
        } else {
            this.setScreenNotReadyYet();
        }
        this.getAssets();
        this.checkScreenStatus();
        this.setBannerInterval();
    }

    componentWillReceiveProps(nextProps) {
        let screenUserData = {};
        if (!this.props.parentScreen) {
            screenUserData = userDataHelper.getScreenUserData(nextProps.userData, this.state.screen.screen_id);
        } else {
            screenUserData = userDataHelper.getSubScreenUserData(nextProps.userData, this.props.parentScreen.screen_id, this.state.screen.screen_id);
        }

        this.setState({userData: Object.assign({}, nextProps.userData)});

        if (this.state.status !== screenUserData.status && screenUserData.status === objectConstants.STATUS_COMPLETE) {
            this.setState({
                status: screenUserData.status,
                setNextButton: true
            });
        }
        if (this.state.lang !== nextProps.lang) {
            this.setState({
                lang: nextProps.lang,
                locale: appHelper.getLocalData(this.state.screen),
                continue_label: appHelper.getLocaleString("continue_label"),
            });
            if (!appHelper.isDefined(this.props.parentScreen)) {
                this.props.actions.setScreenTitle(appHelper.getLocalData(this.state.screen).title);
            }
        }

        if(this.state.showContentOutlineInPreview !== nextProps.showContentOutlineInPreview){
            this.setState({
                showContentOutlineInPreview: nextProps.showContentOutlineInPreview,
                producerNotes: appHelper.getScreenNotes(this.props.parentScreen, this.state.screen, nextProps.showContentOutlineInPreview, this.props.contentData.experience.is_preview),
            });
        }
    }

    componentDidUpdate() {
        let setScrollHeight = this.setScrollHeight;
        setTimeout(function () {
            setScrollHeight();
        }, 500);

        if (this.state.propsUpdated && this.state.reviewMode && this.state.allowReviewMode) {
            this.setReviewMode();
        }

        if (this.state.updateCharacter) {

            this.transitionCharacterExpressions();
        }

        if (this.state.focusOnNextObject) {
            this.focusOnNext();
        }

        if(this.state.setNextButton){
            this.handleNextButton();
        }

        if(this.state.scrollToContent){
            this.scrollToContent();
        }
    }

    componentWillUnmount() {
        this.props.actions.clearAudio();
        window.removeEventListener("resize", this.resizeWatcher);
    }

    setScreenAccessed() {
        this.props.actions.setScreenAccessed(this.state.screen, this.props.parentScreen);
    }

    resizeWatcher() {
        let env = enviromentHelper.getEnvironment();
        if ((env.window.size !== this.state.env.window.size || env.window.orientation !== this.state.env.window.orientation)) {
            this.setState({
                env: env,
                scrollHeight: 0,
                updateHeight: true,
            });
        }
    }


    setScreenNotReadyYet() {
        let completionData = {
            screen_status: objectConstants.STATUS_COMPLETE,
            sub_screen_complete: appHelper.isDefined(this.props.parentScreen) ? true : undefined,
            setNextButton: true
        };

        this.showProgressionButton();

        this.updateScreenResults(completionData);
    }

    checkScreenStatus() {
        let screenUserData = {};
        if (!this.props.parentScreen) {
            screenUserData = userDataHelper.getScreenUserData(this.state.userData, this.state.screen.screen_id);
        } else {
            screenUserData = userDataHelper.getSubScreenUserData(this.state.userData, this.props.parentScreen.screen_id, this.state.screen.screen_id);
        }
        if (this.state.status !== screenUserData.status && screenUserData.status === objectConstants.STATUS_COMPLETE) {
            this.setState({
                status: screenUserData.status,
                setNextButton: true
            });
        }

        this.setState({
            initialStatus: this.state.initialStatus.length === 0 ? screenUserData.status : this.state.initialStatus
        });
        /* let screenStatus = getScreenUserData(this.props.userData, this.props.screen.screen_id).status;
         let reviewMode = screenStatus === objectConstants.STATUS_COMPLETE && localStorage.post_completion_mode === appConstants.POST_COMPLETION_MODE_REVIEW;
        // console.log(`reviewMode: ${this.state.reviewMode} - line 120`);
         this.setState({status: screenStatus, checkCompletionStatus: true, reviewMode: reviewMode, propsUpdated: true});
         */
    }

    setCallbacks() {
        //console.log(`reviewMode: ${this.state.reviewMode} - line 125`);
        this.setState({
            callbacks: Object.assign({}, this.state.biteCallbacks, {
                updateCharacterExpression: this.updateCharacterExpression,
                onObjectComplete: this.onObjectComplete,
                getScreenId: this.getScreenId,
                getBiteId: this.getBiteId,
                storeUserResponse: this.storeUserResponse,
                scrollTo: this.scrollTo,
                isReviewMode: this.isReviewMode,
                getCharacterName: this.getCharacterName,
                hasNextObject: this.hasNextObject,
                navigateToNextScreen: this.navigateToNextScreen,
                getScreenStatus: this.getScreenStatus,
                getSubScreenParent: this.getSubScreenParent,
                goToScreen: this.goToScreen,
                resizeWatcher: this.resizeWatcher,
                checkLearnerDisplayName: this.checkLearnerDisplayName

            })
        });
    }

    getSubScreenParent() {
        return appHelper.isDefined(this.props.parentScreen) ? this.props.parentScreen : undefined;
    }

    getLocale() {
        let locale = appHelper.getLocalData(this.state.screen);
        this.setState({locale: Object.assign({}, locale)});
        if (!appHelper.isDefined(this.props.parentScreen)) {
            this.props.actions.setScreenTitle(locale.title);
        }
    }

    getScreenId() {
        return this.state.screen.screen_id;
    }

    getBiteId() {
        return this.props.biteCallbacks.getBiteId();
    }

    isReviewMode() {
        return this.state.reviewMode;
    }

    getCharacterName() {
        return this.state.locale.character_name;
    }

    getScreenStatus() {
        return this.state.status;
    }

    setReviewMode() {

        let objectsToRender = appHelper.getRenderableObjects(this.props.userData, this.getBiteId(), this.state.screen.objects);
        this.setState(
            {
                screen: Object.assign({}, this.state.screen, {
                    objects: Object.assign([], objectsToRender)
                }),
                propsUpdated: false
            }
        );
        this.renderAllObjects(objectsToRender);
    }

    renderAllObjects(objectsToRender) {
        let renderableObjects = [];
        for (let i = 0; i < objectsToRender.length; i++) {
            let object = objectsToRender[i];
            let objectType = Object.assign({}, getAssetComponentByType(object.asset_type_code),
                {
                    data: object
                }
            );
            renderableObjects = dataHelper.immutablePush(renderableObjects, objectType);
        }
        this.setState({renderedObjects: Object.assign([], renderableObjects), showProgression: true});
    }

    getObject(index) {
        let object = this.state.screen.objects[index];
        let objectType = Object.assign({}, getAssetComponentByType(object.asset_type_code),
            {
                data: object
            }
        );
        //console.log(objectType);
        //let objectLocale = appHelper.getLocalData(object.locale);
        //this.props.actions.setScreenTitle(objectLocale.title);
        this.setState({
            renderedObjects: Object.assign([], dataHelper.immutablePush(this.state.renderedObjects, objectType)),
            focusOnNextObject: this.state.hasReceivedFocus
        });
    }

    getAssets() {
        let backgroundAsset = Object.assign(this.state.assets.background);
        let screenCharacter = {};
        let characterAsset = Object.assign(this.state.assets.character);
        let parentBackground = Object.assign(this.state.parentBackground);

        if (appHelper.isDefined(this.state.screen.assets.background) && !appHelper.isDefined(this.props.parentScreen)) {
            backgroundAsset = appHelper.getBackgroundAsset(this.state.screen.assets.background);
        }

        if (appHelper.isDefined(this.state.screen.assets.character)) {
            screenCharacter = appHelper.getCharacterAsset(this.state.screen.assets.character);
            characterAsset = appHelper.getCharacterPose(screenCharacter, this.state.screen.assets.character);
        }
        if (appHelper.isDefined(this.refs.character)) {
            let characterRef = this.refs.character;
            characterRef.removeAttribute("style");
            if (this.state.allowBlur) {
                TweenLite.set(characterRef, {opacity: 0, '-webkit-filter': 'blur(5px)', 'filter': 'blur(5px)'});
            } else {
                TweenLite.set(characterRef, {opacity: 0});
            }
        }
        if (appHelper.isDefined(this.refs.prevCharacter)) {
            let prevCharacterRef = this.refs.prevCharacter;
            prevCharacterRef.removeAttribute("style");
            if (this.state.allowBlur) {
                TweenLite.set(prevCharacterRef, {opacity: 1, '-webkit-filter': 'blur(0px)', 'filter': 'blur(0px)'});
            } else {
                TweenLite.set(prevCharacterRef, {opacity: 1});
            }
        }

        if (appHelper.isDefined(this.props.parentScreen) && appHelper.isDefined(this.props.parentScreen.assets.background)) {
            parentBackground = appHelper.getBackgroundAsset(this.props.parentScreen.assets.background);
        }

        //console.log(characterAsset);

        this.setState({
            screenCharacter: Object.assign({}, screenCharacter),
            assets: Object.assign({}, this.state.assets, {
                background: backgroundAsset,
                character: characterAsset,
                prevCharacter: characterAsset,
            }),
            parentBackground: Object.assign({}, parentBackground),
        });

    }

    getImagePath(image) {
        if (appConstants.DEVELOPMENT_MODE) {
            if (appHelper.isDefined(image) && image.length > 0) {
                return require(`../../../../moveToDist/${image}`);
            }
        } else {
            return image;
        }
    }

    updateCharacterExpression(pose) {
        if (appHelper.isDefined(pose) && pose.pose !== objectConstants.INHERIT) {
            let characterAsset = appHelper.getCharacterPose(this.state.screenCharacter, pose);

            if (appHelper.isDefined(characterAsset.src) && characterAsset.src.length > 0 && this.state.assets.character.pose !== characterAsset.pose) {
                let characterRef = this.refs.character;
                characterRef.removeAttribute("style");
                if (this.state.allowBlur) {
                    TweenLite.set(characterRef, {opacity: 0, '-webkit-filter': 'blur(5px)', 'filter': 'blur(5px)'});
                } else {
                    TweenLite.set(characterRef, {opacity: 0});
                }
                if (appHelper.isDefined(this.refs.prevCharacter)) {
                    let prevCharacterRef = this.refs.prevCharacter;
                    prevCharacterRef.removeAttribute("style");
                    if (this.state.allowBlur) {
                        TweenLite.set(prevCharacterRef, {
                            opacity: 1,
                            '-webkit-filter': 'blur(0px)',
                            'filter': 'blur(0px)'
                        });
                    } else {
                        TweenLite.set(prevCharacterRef, {opacity: 1});
                    }
                }
                //if (characterAsset.src !== this.state.assets.character.src) {


                this.setState({
                    assets: Object.assign({}, this.state.assets, {
                        character: characterAsset,
                        prevCharacter: this.state.assets.character,

                    }),
                    updateCharacter: true
                });
            }
        }
        //}
    }

    transitionCharacterExpressions() {
        this.setState({updateCharacter: false});
        this.transitionPrevCharacter();
        this.transitionCharacter();

    }

    transitionCharacter() {
        let characterRef = this.refs.character;
        if (this.state.allowBlur) {

            TweenLite.to(characterRef, 0.3, {
                opacity: 1,
                filter: 'blur(0px)',
                ease: Linear.easeIn
            });
        } else {
            TweenLite.set(characterRef, {opacity: 1});
        }
    }

    transitionPrevCharacter() {
        let characterRef = this.refs.prevCharacter;
        if (this.state.allowBlur) {

            TweenLite.to(characterRef, 0.6, {
                opacity: 0,

                filter: 'blur(10px)',
                ease: Linear.easeIn
            });
        } else {
            TweenLite.set(characterRef, {opacity: 0});
        }
    }

    // storeUserResponse(asset_id, selectedOptions, kpis) {
    storeUserResponse(responseObj) {
        //console.log('scroll screen - storeUserResponse');
        let params = Object.assign({}, responseObj, {
            userData: this.props.userData,
            bite_id: this.getBiteId(),
            parent_screen_id: appHelper.isDefined(this.props.parentScreen) ? this.props.parentScreen.screen_id : undefined,
            screen_id: this.getScreenId(),

        });

        //console.log(params);
        this.props.actions.storeUserResponse(params).then((userData) => {
            this.props.actions.setSuspendData(userData);
        }).catch(error => {
        });
    }

    handleNextButton(){
        this.setState({setNextButton: false});
        let next_lesson_location = this.getNextlessonLocation();
        if(next_lesson_location !== 0) {
            this.props.actions.setNextButtonState(true, next_lesson_location);
        }
    }

    getNextlessonLocation(){
        let next_lesson_location = 0;

        if (appHelper.isDefined(this.props.parentScreen)) {

            let hasNextSubScreen = this.props.biteCallbacks.hasNextSubScreen(this.state.screen);
            if (!hasNextSubScreen) {
                let nextScreenId = appHelper.getNextScreenId(this.props.parentScreen.screen_id);
                if (localStorage.bites.length > 1 && nextScreenId.length === 0) {
                    if(appHelper.isDefined(this.props.parentScreen.progression) && (this.props.parentScreen.progression === objectConstants.PROGRESSION_TYPE_OPEN || this.props.parentScreen.progression === objectConstants.PROGRESSION_TYPE_EXPLORE_INTERESTS) && appHelper.isDefined(this.props.closeDialog)){
                        next_lesson_location = 0;
                    }else {
                        next_lesson_location = -1;
                    }
                } else {
                    if(appHelper.isDefined(this.props.parentScreen.progression) && (this.props.parentScreen.progression === objectConstants.PROGRESSION_TYPE_OPEN || this.props.parentScreen.progression === objectConstants.PROGRESSION_TYPE_EXPLORE_INTERESTS) && appHelper.isDefined(this.props.closeDialog)){
                        next_lesson_location = 0;
                    }else {
                        next_lesson_location = nextScreenId;
                    }
                }
            }

        } else {
            let nextScreenId = appHelper.getNextScreenId(this.getScreenId());
            if (localStorage.bites.length > 1 && nextScreenId.length === 0) {
                next_lesson_location = -1;
            } else {
                next_lesson_location = nextScreenId;
            }
        }

        return next_lesson_location;

    }


    navigateToNextScreen() {
        let goToMenu = this.goToMenu;
        if (appHelper.isDefined(this.props.parentScreen)) {
            if (appHelper.isDefined(this.props.closeDialog)) {
                this.props.closeDialog();
            }
            if (this.state.allowGoToScreen && !isNaN(parseInt(this.state.goToScreenId)) && appHelper.screenExists(this.state.goToScreenId)) {
                this.goToScreen(this.state.goToScreenId);
            } else if (this.state.terminateScreen) {
                let nextScreenId = appHelper.getNextScreenId(this.props.parentScreen.screen_id);
                if (localStorage.bites.length > 1 && nextScreenId.length === 0) {
                    setTimeout(() => {
                        goToMenu();
                    }, 500);
                } else {
                    this.props.actions.setNextLessonLocation(nextScreenId);
                }
            } else if (this.state.terminateBite) {
                if (localStorage.bites.length > 1) {
                    setTimeout(() => {
                        goToMenu();
                    }, 500);
                } else {
                    let bite = appHelper.getBiteById(this.props.biteCallbacks.getBiteId());
                    this.goToScreen(bite.screens[0].screen_id);
                }
            } else {
                let hasNextSubScreen = this.props.biteCallbacks.hasNextSubScreen(this.state.screen);
                if (hasNextSubScreen) {
                    this.props.biteCallbacks.goToNextSubScreen(this.state.screen);
                } else {
                    if(appHelper.isSingleScreenModule()) {
                        this.setState({showEndOfScreenMessage: true});
                    }else {
                        let nextScreenId = appHelper.getNextScreenId(this.props.parentScreen.screen_id);
                        if (localStorage.bites.length > 1 && nextScreenId.length === 0) {
                            if (appHelper.isDefined(this.props.parentScreen.progression) && (this.props.parentScreen.progression === objectConstants.PROGRESSION_TYPE_OPEN || this.props.parentScreen.progression === objectConstants.PROGRESSION_TYPE_EXPLORE_INTERESTS) && appHelper.isDefined(this.props.closeDialog)) {
                                return false;
                            } else {
                                setTimeout(() => {
                                    goToMenu();
                                }, 500);
                            }
                        } else {
                            if (appHelper.isDefined(this.props.parentScreen.progression) && (this.props.parentScreen.progression === objectConstants.PROGRESSION_TYPE_OPEN || this.props.parentScreen.progression === objectConstants.PROGRESSION_TYPE_EXPLORE_INTERESTS) && appHelper.isDefined(this.props.closeDialog)) {
                                return false;
                            } else {
                                let goToScreen = this.goToScreen;
                                setTimeout(() => {
                                    goToScreen(nextScreenId);
                                }, 500);
                            }
                        }
                    }
                }
            }
        } else {
            if(appHelper.isSingleScreenModule()){
                this.setState({showEndOfScreenMessage: true});
            }else {
                if (this.state.allowGoToScreen && !isNaN(parseInt(this.state.goToScreenId)) && appHelper.screenExists(this.state.goToScreenId)) {
                    this.goToScreen(this.state.goToScreenId);
                } else if (this.state.terminateBite) {
                    if (localStorage.bites.length > 1) {
                        setTimeout(() => {
                            goToMenu();
                        }, 500);
                    } else {
                        let bite = appHelper.getBiteById(this.props.biteCallbacks.getBiteId());
                        this.goToScreen(bite.screens[0].screen_id);
                    }
                } else {
                    let nextScreenId = appHelper.getNextScreenId(this.getScreenId());
                    if (localStorage.bites.length > 1 && nextScreenId.length === 0) {
                        setTimeout(() => {
                            goToMenu();
                        }, 500);
                    } else {
                        this.goToScreen(nextScreenId);
                    }
                }
            }
        }
    }

    goToMenu() {
        this.context.router.push('menu');
    }

    goToScreen(goTo) {
        this.props.actions.setNewLessonLocation(goTo);

    }

    handleObjectProgression() {

    }

    handleContinue(completionData) {
        let currentIndex = appHelper.getArrayObjectIndexByKey(this.state.screen.objects, "asset_id", completionData.asset_id);
        if (currentIndex < (this.state.screen.objects.length - 1)) {

            let newIndex = currentIndex + 1;
            this.setState({currentObjectIndex: newIndex});
            this.getObject(newIndex);
            if (this.state.status !== objectConstants.STATUS_COMPLETE) {
                //this.updateScreenResults(objectConstants.STATUS_IN_PROGRESS, asset_id, response);
            } else {
                // this.updateScreenResults(objectConstants.STATUS_COMPLETE, asset_id, response);
            }
            completionData = Object.assign({}, completionData, {
                screen_status: this.state.status !== objectConstants.STATUS_COMPLETE ? objectConstants.STATUS_IN_PROGRESS : objectConstants.STATUS_COMPLETE
            });

            this.updateScreenResults(completionData);
        } else {
            this.setState({
                allowScroll: appHelper.AllowAutoProgressionIfLast(completionData.asset_type_code)
            });
            if (appHelper.isDefined(this.props.parentScreen)) {
                //////////////////////
                //COMPLETE SUB SCREEN
                /////////////////////

                this.setState({setNextButton: true});
                if (!completionData.navigateToNextScreen && (!appHelper.isDefined(completionData.showProgressionButton) || (appHelper.isDefined(completionData.showProgressionButton) && completionData.showProgressionButton))) {
                    this.showProgressionButton();
                }
                completionData = Object.assign({}, completionData, {
                    screen_status: objectConstants.STATUS_COMPLETE,
                    sub_screen_complete: true,
                });

                this.updateScreenResults(completionData);


            } else {
                this.setState({setNextButton: true});

                if (!completionData.navigateToNextScreen && (!appHelper.isDefined(completionData.showProgressionButton) || (appHelper.isDefined(completionData.showProgressionButton) && completionData.showProgressionButton))) {
                    this.showProgressionButton();
                }
                completionData = Object.assign({}, completionData, {
                    screen_status: objectConstants.STATUS_COMPLETE,

                });
                this.updateScreenResults(completionData);
                //////////////////////
                //COMPLETE SCREEN
                /////////////////////
                //console.log(`complete screen`);
            }
        }
    }

    onObjectComplete(completionData) {
        if (completionData.progression === objectConstants.OBJECT_PROGRESSION_CONTINUE || completionData.progression === objectConstants.OBJECT_PROGRESSION_AUTO) {
            this.handleContinue(completionData);
        } else if (completionData.progression === objectConstants.OBJECT_PROGRESSION_GO_TO) {
            if (completionData.progressionType === objectConstants.GO_TO_TYPE_OBJECT) {
                let nextObjectIndex = appHelper.getArrayObjectIndexByKey(this.state.screen.objects, "asset_id", completionData.progressionGoToId);
                this.setState({currentObjectIndex: nextObjectIndex});
                this.getObject(nextObjectIndex);
                this.updateScreenResults(completionData);
            } else if (completionData.progressionType === objectConstants.GO_TO_TYPE_SCREEN && appHelper.screenExists(completionData.progressionGoToId)) {
                this.setState({
                    allowGoToScreen: true,
                    goToScreenId: completionData.progressionGoToId,
                    allowScroll: appHelper.AllowAutoProgressionIfLast(completionData.asset_type_code)
                });

                if (appHelper.isDefined(this.props.parentScreen)) {
                    //////////////////////
                    //COMPLETE SUB SCREEN
                    /////////////////////
                    if (!completionData.navigateToNextScreen || (completionData.navigateToNextScreen && this.state.initialStatus === objectConstants.STATUS_COMPLETE)) {
                        this.showProgressionButton();
                    }
                    completionData = Object.assign({}, completionData, {
                        screen_status: objectConstants.STATUS_COMPLETE,
                        sub_screen_complete: true
                    });

                    this.updateScreenResults(completionData);


                } else {
                    if (!completionData.navigateToNextScreen || (completionData.navigateToNextScreen && this.state.initialStatus === objectConstants.STATUS_COMPLETE)) {
                        this.showProgressionButton();
                    }
                    completionData = Object.assign({}, completionData, {
                        screen_status: objectConstants.STATUS_COMPLETE,
                        setNextButton: true
                    });
                    this.updateScreenResults(completionData);
                    //////////////////////
                    //COMPLETE SCREEN
                    /////////////////////
                    //console.log(`complete screen`);
                }
            } else {
                this.handleContinue(completionData);
            }

        } else if (completionData.progression === objectConstants.OBJECT_PROGRESSION_TERMINAL) {
            if (completionData.progressionType === objectConstants.TERMINAL_TYPE_SCREEN) {
                this.setState({
                    terminateScreen: true,
                    allowScroll: appHelper.AllowAutoProgressionIfLast(completionData.asset_type_code)
                });

                if (appHelper.isDefined(this.props.parentScreen)) {
                    //////////////////////
                    //COMPLETE SUB SCREEN
                    /////////////////////
                    this.props.biteCallbacks.completeScreen();

                    if (!completionData.navigateToNextScreen || !completionData.showProgression || (completionData.navigateToNextScreen && this.state.initialStatus === objectConstants.STATUS_COMPLETE)) {
                        this.showProgressionButton();
                    }
                    completionData = Object.assign({}, completionData, {
                        screen_status: objectConstants.STATUS_COMPLETE,
                        sub_screen_complete: true,
                        setNextButton: true
                    });

                    this.updateScreenResults(completionData);


                } else {

                    if (!completionData.navigateToNextScreen || !completionData.showProgression || (completionData.navigateToNextScreen && this.state.initialStatus === objectConstants.STATUS_COMPLETE)) {
                        this.showProgressionButton();
                    }
                    completionData = Object.assign({}, completionData, {
                        screen_status: objectConstants.STATUS_COMPLETE,
                        setNextButton: true
                    });
                    this.updateScreenResults(completionData);
                    //////////////////////
                    //COMPLETE SCREEN
                    /////////////////////
                    //console.log(`complete screen`);
                }
            } else if (completionData.progressionType === objectConstants.TERMINAL_TYPE_BITE) {
                this.setState({
                    terminateBite: true,
                    allowScroll: appHelper.AllowAutoProgressionIfLast(completionData.asset_type_code)
                });

                let bite = appHelper.getBiteById(this.props.biteCallbacks.getBiteId());
                this.props.actions.terminateBite(bite).then((userData) => {


                    if (!completionData.navigateToNextScreen || !completionData.showProgression || (completionData.navigateToNextScreen && this.state.initialStatus === objectConstants.STATUS_COMPLETE)) {
                        this.showProgressionButton();
                    }

                    if (appHelper.isDefined(this.props.parentScreen)) {
                        this.props.biteCallbacks.completeScreen();
                    }

                    completionData = Object.assign({}, completionData, {
                        screen_status: objectConstants.STATUS_COMPLETE,
                        setNextButton: true
                    });

                    this.updateScreenResults(completionData);

                }).catch(error => {
                });
            }
        }
    }

    updateScreenResults(completionData) {
        let params = Object.assign({}, completionData, {
            bite_id: this.getBiteId(),
            parent_screen_id: appHelper.isDefined(this.props.parentScreen) ? this.props.parentScreen.screen_id : undefined,
            screen_id: this.getScreenId(),
            object_status: completionData.status,
            object_result: {}
        });
        this.props.actions.updateScreenResults(params).then((userData) => {
            if (appHelper.isDefined(completionData.sub_screen_complete) && completionData.sub_screen_complete) {
                this.props.biteCallbacks.onSubScreenComplete(this.state.screen);
            }
            this.props.actions.setSuspendData(userData).then((trackingData) => {
                if (completionData.screen_status === objectConstants.STATUS_COMPLETE) {
                    this.props.actions.setScreenComplete(this.state.screen, this.props.parentScreen);
                }

                if ((completionData.navigateToNextScreen && this.state.initialStatus !== objectConstants.STATUS_COMPLETE) && this.state.allowGoToScreen) {
                    this.navigateToNextScreen();
                }
                /*let objectIndex = appHelper.getArrayObjectIndexByKey(this.state.screen.objects,"asset_id",completionData.asset_id);
                if (completionData.screen_status === objectConstants.STATUS_COMPLETE  && objectIndex === this.state.screen.objects.length - 1) {

                    if (appHelper.AllowAutoProgressionIfLast(completionData.asset_type_code)) {
                        if (this.state.initialStatus !== objectConstants.STATUS_COMPLETE  && !appHelper.isDefined(this.props.closeDialog)) {
                            this.navigateToNextScreen();
                        } else {

                            if (!completionData.navigateToNextScreen) {
                                this.showProgressionButton();
                            }
                        }

                    }
                }*/
            }).catch(error => {
            });
        }).catch(error => {
        });
    }

    showProgressionButton() {
        let nextScreenId = appHelper.getNextScreenId(this.state.screen.screen_id);
        //if (nextScreenId.length > 0) {
        this.setState({showProgression: true});
        this.scrollToTop();
        //}
    }

    scrollTo(pos, allow) {
        if (this.state.status !== objectConstants.STATUS_COMPLETE || (appHelper.isDefined(allow) && allow) && appHelper.isDefined(pos)) {
            let feed = this.objectFeed.current;

            if (appHelper.isEleDefined(feed) && feed.scrollTop < pos) {

                let params = {
                    ele: feed,
                    duration: objectConstants.SCROLL_SPEED,
                    delay: 0,
                    scrollTop: pos,
                    callback: this.onScrollComplete
                };

                animationHelper.scrollTo(params);
            }
        }
    }

    scrollToOnComplete(pos) {
        let feed = this.objectFeed.current;
        if (appHelper.isEleDefined(feed) && feed.scrollTop < pos) {
            let params = {
                ele: feed,
                duration: objectConstants.SCROLL_SPEED,
                delay: 0,
                scrollTop: pos,
                callback: this.onScrollComplete
            };
            animationHelper.scrollTo(params);
        }
    }

    onContinueBtnReveled() {
        this.scrollToTop();
    }

    scrollToTop() {
        if (this.state.initialStatus !== objectConstants.STATUS_COMPLETE && this.state.allowScroll) {

            let anchor = this.bottomAnchor.current;
            let scrollTo = this.scrollTo;
            if(appHelper.isEleDefined(anchor)) {
                setTimeout(function () {
                    scrollTo(anchor.offsetTop);

                }, 1000);
            }

        }
    }

    onScrollComplete() {

    }

    hasNextObject(objectIndex) {
        //let objectIndex = appHelper.getArrayObjectIndexByKey(this.state.screen.objects, "asset_id", object.asset_id);
        return objectIndex < (this.state.screen.objects.length - 1);
    }

    getFeedClass() {
        return this.state.allowClippedBlurEffect ? 'blurred-feed' : 'standard-feed';
    }

    getPanelStyle() {
        if (!appHelper.isDefined(this.props.parentScreen)) {
            return appHelper.isDefined(this.state.screen.panel_style) ? this.state.screen.panel_style : "frosted_white";
        } else {
            return this.props.parentScreen.screen_type === componentConstants.SCREEN_TYPE_TABBED
            &&
            (this.props.parentScreen.tab_type === objectConstants.TAB_TYPE_HORIZONTAL_FRAMELESS || this.props.parentScreen.tab_type === objectConstants.TAB_TYPE_VERTICAL_FRAMELESS)
            &&
            appHelper.isDefined(this.props.parentScreen.panel_style)
                ? this.props.parentScreen.panel_style
                : "";
        }
    }

    setFocusRecieved() {
        this.setState({hasReceivedFocus: true});
    }

    focusOnNext() {
        this.setState({focusOnNextObject: false});
        let object = this.state.renderedObjects[this.state.renderedObjects.length - 1];
        let focusEl = document.getElementById(`object_${object.data.asset_id}`);
        focusEl.focus();
    }

    setScrollHeight() {
        let lastObjectData = this.state.renderedObjects[this.state.renderedObjects.length - 1];
        let overwrite = false;
        if (appHelper.isDefined(lastObjectData)) {
            let lastObject = document.getElementById(`object_${lastObjectData.data.asset_id}`);
            let feed = this.objectFeed.current;
            let scrollContainer = this.objectFeedContainer.current;
            if (appHelper.isDefined(scrollContainer) && scrollContainer !== null) {
                let scrollHeight = scrollContainer.scrollHeight;
                let objectEndPos = lastObject.offsetTop + lastObject.offsetHeight;
                //let difference = feed.offsetHeight - lastObject.offsetHeight;
                let endPosIntoFeed = Math.round(objectEndPos / feed.offsetHeight);
                let scrollHeightIntoFeed = Math.round(scrollHeight / feed.offsetHeight);
                //console.log(lastObject);
                //console.log('lastObject scrollPosition = ', lastObject.offsetTop);
                //console.log('lastObject height = ', lastObject.offsetHeight);
                //console.log('scrollHeight = ', scrollHeight);
                //console.log('feed height = ', feed.offsetHeight);
                //console.log(' object end pos = ',  objectEndPos);
                //console.log(' obect end pos into feedHeights', Math.round(objectEndPos / feed.offsetHeight));
                //console.log(' scroll height into feedHeight', Math.round(scrollHeight / feed.offsetHeight));
                //CANT REMEMBER WHY THIS WAS HERE ? :/ - keep incase I do...
                /*if (scrollHeightIntoFeed > endPosIntoFeed) {
                    console.log(`scrollHeightIntoFeed`,scrollHeightIntoFeed);
                    console.log(`endPosIntoFeed`,endPosIntoFeed);
                    overwrite = true;
                    scrollHeight = feed.offsetHeight * endPosIntoFeed;
                    console.log(`scrollHeight`,scrollHeight);
                    //scrollHeight =  objectEndPos + difference - 40;
                    //console.log(`remainder difference = `,difference);
                    //console.log('new height options',feed.offsetHeight * endPosIntoFeed,' or ',objectEndPos + difference);
                }*/
                if (scrollHeight > this.state.scrollHeight || overwrite) {
                   // console.log(`scrollHeight > this.state.scrollHeight`,scrollHeight, this.state.scrollHeight);
                    this.setState({scrollHeight: scrollHeight});
                }
            }
        }
    }

    allowInheritParentPanelStyle() {
        return appHelper.isDefined(this.props.parentScreen)
            &&
            this.props.parentScreen.screen_type === componentConstants.SCREEN_TYPE_TABBED
            &&
            (this.props.parentScreen.tab_type === objectConstants.TAB_TYPE_HORIZONTAL_FRAMELESS || this.props.parentScreen.tab_type === objectConstants.TAB_TYPE_VERTICAL_FRAMELESS)
            &&
            appHelper.isDefined(this.props.parentScreen.panel_style);
    }

    getProducerContentClass() {
        return !this.state.screenIsReady || !this.state.producerNotes.show_content ? "floating-notes" : "";
    }

    getProducerContentHeight() {
        if (!this.state.screenIsReady || !this.state.producerNotes.show_content) {
            let scrollContainer = this.objectFeedContainer.current;
            if (appHelper.isDefined(scrollContainer) && scrollContainer !== null) {
                return scrollContainer.offsetHeight -1;
            }
        } else {
            return 0;
        }
    }

    checkLearnerDisplayName(){
        return appHelper.isDefined(this.state.screen.learner_name_display_type) && this.state.screen.learner_name_display_type === objectConstants.LEARNER_NAME_DISPLAY_TYPE_CUSTOM && this.state.locale.learner_name.length > 0 ? this.state.locale.learner_name : "";
    }

    checkScreenState(){
        return !this.state.screenIsReady || !this.state.producerNotes.show_content ? "outline-view" : "";
    }


    setBannerInterval(){
        let objectFeed = this.objectFeed.current;
        if(appHelper.isDefined(objectFeed) && objectFeed !== null){
            let interval = setInterval(this.getBackgroundBannerPlacement, 1);
            this.setState({bannerInterval: interval});
        }
    }

    getBackgroundBannerPlacement(){
        let backgroundPosition =  this.state.backgroundPosition;
        let objectFeed = this.objectFeed.current;
        let startBanner  = this.startBanner.current;
        if(appHelper.isDefined(startBanner) && startBanner !== null) {
            if(objectFeed.offsetTop <= (startBanner.clientHeight + 20)) {
                backgroundPosition = "content";
                clearInterval(this.state.bannerInterval);
            }
        }

        if(backgroundPosition !== this.state.backgroundPosition) {
            this.setState({backgroundPosition: backgroundPosition, scrollToContent: true});
        }
    }

    scrollToContent(){

        this.setState({scrollToContent: false});
        let objectFeed = this.objectFeed.current;
        if(appHelper.isDefined(objectFeed) && objectFeed !== null) {

            let params = {
                ele: objectFeed,
                duration: objectConstants.SCROLL_SPEED,
                delay: 0,
                scrollTop: objectFeed.offsetHeight,
                callback: this.onScrollComplete
            };

            animationHelper.scrollTo(params);
        }

    }


    render() {
        return (
            <div className="customer-scenario">
                <div className="background-container blur">
                    {
                        !appHelper.isDefined(this.props.parentScreen) && (!this.state.screen.use_bg_as_banner_on_devices || (this.state.screen.use_bg_as_banner_on_devices && this.state.env.window.orientation !== objectConstants.ORIENTATION_PORTRAIT))
                            ?
                            <img className="blur" src={this.getImagePath(this.state.assets.background.src)} alt=""/>
                            :
                            null
                    }

                </div>

                {
                    !appHelper.isDefined(this.props.parentScreen) && !this.state.is_resource_screen && this.state.screen.use_bg_as_banner_on_devices && this.state.env.window.orientation === objectConstants.ORIENTATION_PORTRAIT
                        ?

                        <div className={`screen-bg-banner ${this.state.backgroundPosition !== 'top' ? "hide" : ""}`} >
                            <img src={this.getImagePath(this.state.assets.background.src)} ref={this.startBanner}
                                 alt=""/>
                        </div>

                        :
                        null
                }
                <div className={`screen-container ${this.getPanelStyle()}`}>
                    <div className="character-stage">

                        {
                            appHelper.isDefined(this.state.screenCharacter.position)
                                ?
                                <div className={this.state.screenCharacter.position}>
                                    <img className="character-image" ref="character"
                                         src={this.getImagePath(this.state.assets.character.src)} alt=""/>
                                    {this.state.assets.prevCharacter.src.length > 0
                                        ?
                                        <img className="prev-character-image" ref="prevCharacter"
                                             src={this.getImagePath(this.state.assets.prevCharacter.src)} alt=""/>
                                        :
                                        null
                                    }
                                </div>
                                :
                                null
                        }

                    </div>
                    {
                        !appHelper.isDefined(this.props.parentScreen) && this.state.allowClippedBlurEffect
                            ?
                            <div className={`feed-background `}>
                                <img className="blur" src={this.getImagePath(this.state.assets.background.src)} alt=""/>
                            </div>
                            :
                            null
                    }

                    {
                        this.allowInheritParentPanelStyle() && this.state.allowClippedBlurEffect
                            ?
                            <div className={`feed-background `}>
                                <img className="blur" src={this.getImagePath(this.state.parentBackground.src)} alt=""/>
                            </div>
                            :
                            null
                    }

                    <div className={`object-feed ${this.getFeedClass()} ${this.checkScreenState()}`} id={`${this.state.screen.screen_id}_feed_id`}
                         ref={this.objectFeed} role="article">

                        <div className="feed-container" ref={this.objectFeedContainer}
                             style={{minHeight: `${this.state.scrollHeight}px`}}>
                            {
                                this.state.producerNotes.show_notes || !this.state.screenIsReady || !this.state.producerNotes.show_content
                                    ?
                                    <div className={`${this.getProducerContentClass()}`}
                                         style={{minHeight: this.getProducerContentHeight()}}>
                                        {
                                            this.state.producerNotes.show_notes
                                                ?
                                                <ProducerNotes notes={this.state.producerNotes.notes}
                                                               screen_id={this.state.screen.screen_id}/>
                                                :
                                                null
                                        }
                                        {
                                            !this.state.screenIsReady || !this.state.producerNotes.show_content
                                                ?
                                                <NotReadyYet screen_id={this.state.screen.screen_id}
                                                             onContinue={this.navigateToNextScreen}/>
                                                :
                                                null
                                        }

                                    </div>
                                    :
                                    null
                            }


                                    <div className={`screen-bg-banner ${ !appHelper.isDefined(this.props.parentScreen) && !this.state.is_resource_screen && this.state.screen.use_bg_as_banner_on_devices && this.state.env.window.orientation === objectConstants.ORIENTATION_PORTRAIT && this.state.backgroundPosition === "content" ? "" : "hide"}`}>
                                        <img src={this.getImagePath(this.state.assets.background.src)}
                                             alt=""/>
                                    </div>


                            {
                                this.state.screenIsReady && this.state.producerNotes.show_content && this.state.renderedObjects.length > 0 && this.state.producerNotes.show_content
                                    ?
                                    this.state.renderedObjects.map((object, index) =>
                                        <div className={`feed-object-container`} key={index} role="article"
                                             tabIndex="0" id={`object_${object.data.asset_id}`}
                                             onFocus={this.setFocusRecieved}>
                                            <object.component screenObject={object.data}
                                                              callbacks={this.state.callbacks}
                                                              index={appHelper.getArrayObjectIndexByKey(this.state.screen.objects, "asset_id", object.data.asset_id)}
                                            />
                                        </div>
                                    )
                                    :

                                    null
                            }

                            {
                                !this.state.screenIsReady || !this.state.producerNotes.show_content
                                    ?
                                    <div className="feed-object-container first-child">
                                        <ProtoType/>
                                    </div>
                                    :
                                    null
                            }


                            {this.state.showProgression
                                ? <Button ref={`${this.state.screen.screen_id}_button`}
                                          label={this.state.continue_label}
                                          id={`${this.state.screen.screen_id}_button`}
                                          onClick={this.navigateToNextScreen}
                                          onRevealed={this.onContinueBtnReveled}
                                />
                                : null
                            }

                            {this.state.showEndOfScreenMessage ?
                                <EndOfScreen/>
                                :
                                null
                            }
                            <div ref={this.bottomAnchor}/>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

ScenarioScreen.propTypes = {
    screen: PropTypes.object.isRequired,
    biteCallbacks: PropTypes.object.isRequired,
    parentScreen: PropTypes.object,
    contentData: PropTypes.object.isRequired,
    trackingData: PropTypes.object.isRequired,
    userData: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
    closeDialog: PropTypes.func,
    lang: PropTypes.string.isRequired,
    audio: PropTypes.object.isRequired,
    showContentOutlineInPreview: PropTypes.bool.isRequired,
};

ScenarioScreen.contextTypes = {
    router: PropTypes.object
};

function mapStateToProps(state, ownProps) {
    let lang = state.userData.lang;
    return {
        lang: lang,
        contentData: state.contentData,
        trackingData: state.trackingData,
        userData: state.userData,
        audio: state.audio,
        showContentOutlineInPreview: state.showContentOutlineInPreview,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign({}, appDataActions, trackingDataActions, userDataActions), dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(ScenarioScreen);



/** WEBPACK FOOTER **
 ** ./src/components/screens/scenarioScreen/ScenarioScreen.js
 **/